import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectAccountMFAEnabled,
  selectAccountMFAEnabledDataState,
} from '../state';
import { useMemo } from 'react';

function useMFAEnabled() {
  const mfaEnabled = useSelector(selectAccountMFAEnabled);
  const mfaEnabledDataState = useSelector(selectAccountMFAEnabledDataState);

  const returnObj = useMemo(
    () => ({
      mfaEnabled,
      isUpdating: Boolean(mfaEnabledDataState.match('pending|refreshing')),
    }),
    [mfaEnabled, mfaEnabledDataState],
  );

  return returnObj;
}

export default useMFAEnabled;
